import React, { Component } from 'react';

import PopUpMenu from './PopUpMenu.js';

class PopUpMenuContainer extends Component
{
    constructor(props) {
        super(props);
        this.closeOnDocumentClick = this.closeOnDocumentClick.bind(this);
        this.setRef = this.setRef.bind(this);
    }

    closeOnDocumentClick(e) {
        if(e.target!==this.ref && this.ref && !this.ref.contains(e.target)) {
            this.props.onClose && this.props.onClose();
        }
    }

    componentWillMount() {
        document.addEventListener('click', this.closeOnDocumentClick)
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeOnDocumentClick)
    }

    setRef(ref) {
        this.ref = ref;
    }

    render() {
        return <PopUpMenu {...this.props} setRef={this.setRef} />
    }
}

export default PopUpMenuContainer;



// WEBPACK FOOTER //
// ./src/modules/navigation/PopUpMenuContainer.js